import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeightBold};
  line-height: 26px;
`;

const Image = styled.img`
  margin-top: 64px;
  height: 117px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
`;

const QueryString = styled.span`
  color: ${props => props.theme.primaryColor};
`;

const Tip = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => (props.theme.isMobile ? `
      padding: 20px 20px;
      margin: 49px -20px;
    ` : `
      padding: 27px 35px;
      margin: 49px -26px 0 -26px;
    `)};
  border-radius: 3px;
  background: ${props => props.theme.tooltipBackgroundColor};
`;

const TipHeader = styled.span`
  text-transform: uppercase;
  font-size: 16px;
`;

export default function NoSimilar({ query }) {
  return (
    <Container>
      <Image src={window.getLivewireAssetPath('search-no-results.svg')} alt="Success" />
      <TextContainer>
        <span>Sorry, we couldn&apos;t find any wires relating to</span>
        <span>
          &quot;
          <QueryString>{query}</QueryString>
          &quot;
        </span>
      </TextContainer>
      <Tip>
        <TipHeader>Search tip:</TipHeader>
        <span>
          Make sure your search is specific,
          then select one of our Suggested Searches in the search dropdown.
        </span>
      </Tip>
    </Container>
  );
}

NoSimilar.propTypes = {
  query: PropTypes.string.isRequired,
};
